module.exports = __webpack_public_path__ + "img/bf_gocase_2024.03cd09d.webp";